
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/boats/[id]",
      function () {
        return require("private-next-pages/boats/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/boats/[id]"])
      });
    }
  